<template>
  <div class="airConditioningCom">
    <div class="leftMenu">
      <div
        v-for="(item, index) in dataList"
        :key="index"
        :class="{ txtLi: true, activeTxtLi: activeItem.id == item.id }"
        @click="changeMenu(item)"
      >
        <el-tooltip
          class="item"
          effect="dark"
          :content="item.name"
          placement="top-start"
          :disabled="item.name?.length < 15"
        >
          <p>
            {{ item.name }}
          </p>
        </el-tooltip>
      </div>
    </div>
    <div class="rightPanel">
      <AirConditioningPanel
        :activeItem="activeItem"
        @handeleData="handeleData"
      />
    </div>
  </div>
</template>

<script>
import AirConditioningPanel from "./AirConditioningPanel";
export default {
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  components: { AirConditioningPanel },
  data() {
    return {
      activeItem: {},
    };
  },
  watch: {
    dataList: {
      handler() {
        this.activeItem = this.dataList.length ? this.dataList[0] : {};
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    changeMenu(item) {
      this.activeItem = item;
    },
    handeleData(data) {
      this.$emit("changeState", data);
    },
  },
};
</script>

<style lang="scss" scoped>
.airConditioningCom {
  width: 100%;
  height: 100%;
  @include setFlexBetween;
  .leftMenu {
    width: 43%;
    height: 100%;
    overflow: auto;
    .txtLi {
      height: 38px;
      background: #fafafa;
      line-height: 38px;
      border-radius: 2px;
      margin-bottom: 10px;
      cursor: pointer;
      p {
        padding: 0 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &:hover {
        background: #e6f9f9;
      }
    }
    .activeTxtLi {
      background: $themeColor !important;
      color: #fff;
    }
  }
  .rightPanel {
    width: 55%;
    height: 100%;
    border-left: 1px solid #e9e9e9;
  }
}
</style>
